<template>
	<frontend-layout>
		<Head>
			<title>{{ $t("softwareList") }} - {{ $t("siteTitle") }}</title>
		</Head>
		<template #header>
			<h1 class="page-title p-0">{{ $t("softwareList") }}</h1>
		</template>

		<template #breadcrumb>
			<div class="pageInfo mb-2 p-1">
				<div class="page-breadcrumb float-sm-right">
					<ol class="breadcrumb">
						<li class="breadcrumb-item">
							<InertiaLink
								:href="'/'"
								:class="{
									active: $page.url === '/',
								}">
								{{ $t("home") }}
							</InertiaLink>
						</li>
						<li class="breadcrumb-item">
							{{ $t("softwareList") }}
						</li>
					</ol>
				</div>
			</div>
		</template>
		<section>
			<div class="container">
				<div
					v-for="softwareCategory in this.$props.softwareCategories"
					:key="softwareCategory.software_category_id">
					<div
						class="ts-box"
						v-if="softwareCategory.softwares.length > 0">
						<table class="ts-table">
							<thead>
								<tr>
									<th colspan="7" class="ts-text is-huge">
										{{
											$i18n.locale == "zh-TW"
												? softwareCategory.title
												: softwareCategory.title_en
										}}
									</th>
								</tr>
								<tr>
									<th>{{ $t("softList.name") }}</th>
									<th>{{ $t("softList.employee") }}</th>
									<th>{{ $t("softList.student") }}</th>
									<th>{{ $t("softList.32bit") }}</th>
									<th>{{ $t("softList.64bit") }}</th>
									<th>{{ $t("softList.zh") }}</th>
									<th>{{ $t("softList.en") }}</th>
								</tr>
							</thead>
							<tbody>
								<tr
									v-for="software in softwareCategory.softwares"
									:key="software.software_id">
									<td>
										{{
											$i18n.locale == "zh-TW"
												? software.title
												: software.title_en
										}}
									</td>
									<td>
										<span
											v-if="hasRole(software, 3)"
											class="
												ts-icon
												is-check-icon
											"></span>
									</td>
									<td>
										<span
											v-if="hasRole(software, 2)"
											class="
												ts-icon
												is-check-icon
											"></span>
									</td>
									<td>
										<span
											v-if="hasBit(software, 1)"
											class="
												ts-icon
												is-check-icon
											"></span>
									</td>
									<td>
										<span
											v-if="hasBit(software, 2)"
											class="
												ts-icon
												is-check-icon
											"></span>
									</td>
									<td>
										<span
											v-if="hasLang(software, 1)"
											class="
												ts-icon
												is-check-icon
											"></span>
									</td>
									<td>
										<span
											v-if="hasLang(software, 2)"
											class="
												ts-icon
												is-check-icon
											"></span>
									</td>
								</tr>
							</tbody>
						</table>
					</div>
					<div v-if="softwareCategory.softwares.length > 0">
						<div class="ts-space"></div>
						<div class="ts-space"></div>
					</div>
				</div>
			</div>
		</section>
	</frontend-layout>
</template>

<script>
// import components
import FrontendLayout from "@/Frontend/Shared/Layout";

export default {
	name: "softwareList",
	props: {
		softwareCategories: Array,
	},
	data() {
		return {};
	},
	methods: {
		hasRole(software, role_id) {
			return software.granted_member.includes(role_id);
		},
		hasBit(software, bit_id) {
			if (software.software_files.length == 0) return false;
			return software.software_files.some(function (file) {
				if (file.bit_id == bit_id || file.bit_id == 3) {
					return true;
				}
			});
		},
		hasLang(software, lang_id) {
			if (software.software_files.length == 0) return false;
			return software.software_files.some(function (file) {
				if (file.lang_id == lang_id || file.lang_id == 3) {
					return true;
				}
			});
		},
	},
	mounted() {},
	components: {
		FrontendLayout,
	},
};
</script>

<style scoped></style>
